import React, { useMemo, useState, useEffect, useContext } from 'react';
import 'rodal/lib/rodal.css';
import PropTypes from 'prop-types';
import { styled, css, width, height } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import Fade from '@mui/material/Fade';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/icon/Icon';
import LANG, { getLangWithKey } from '../../../lang';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Select from '../../../components/bootstrap/forms/Select';
import Button from '../../../components/bootstrap/Button';
import './ProductMenuModal.css';
import { CardLabel, CardTitle } from '../../../components/bootstrap/Card';
import Input from '../../../components/bootstrap/forms/Input';
import { userAuth } from '../../../contexts/userContext';
import CommonAPIService from '../../../api/CommonAPIService';
import apiService from '../../../api/apiService';
import { useNavigate } from 'react-router-dom';
import { CartConfModal } from './proCartModal';
import Label from '../../../components/bootstrap/forms/Label';
import { CartContext } from '../../../contexts/CartContext';

export const ProductMenuModal = ({
	// productList,
	// setProductList,
	loadalert,
	closemodel,
	confirmbt,
	data,
	// selectedPr,
	// branchId,
}) => {
	const { t } = useTranslation();
	const { i18n } = useTranslation();
	const { token, setToken } = useContext(userAuth);
	const currentLang = getLangWithKey(i18n.language);
	const matches = useMediaQuery('(max-width:600px)');
	const [selectedItem, setSelectedItem] = useState('');
	const [selectorError, setSelectorError] = useState({ error: false, msg: t('*Required') });
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [quantityError, setQuantityError] = useState({});
	const APIService = CommonAPIService();
const [qty, setQty] = useState(1);
	const [isMobile, setIsMobile] = useState(false);
	const [loadalert1, setLoadalert1] = useState(false);
	const [msgloadalert, setMsgLoadalert] = useState('');
	const [msgtypeloadalert, setMsgtypeLoadalert] = useState('');
	const [condialog, setCondialog] = useState(false);

	const availableStock = Number(data?.qty);
const hasStock = !Number.isNaN(availableStock);
const isIncreaseDisabled = hasStock ? qty >= availableStock : false;

	const navigate = useNavigate();
	const [newpropererror, setNewpropererror] = useState({
		Quantity: { error: false, msg: t('*Required') },
	});
	const [proper, setNewproper] = useState('');
	
	const [proqty, setProqty] = useState('');
	const [qtyError, setQtyError] = useState({ error: false, msg: t('*Required') });
	const totprice = useMemo(() => {
		const cleanPrice = Number((data.price_nf || '0').replace(/,/g, ''));
		return qty * cleanPrice;
	}, [qty, data.price_nf]);

	const { addItemToCart } = useContext(CartContext);
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 678);
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const OnClickToCustomer = () => {
		navigate('/products');
	};
	const OnClickToCart = () => {
		navigate('/cart');
	};
	const startmodel2 = () => {
		setCondialog(true);
	};

	const closemodel2 = () => {
		setLoadalert1(false);
	};
	const startmodel = () => {
		setLoadalert1(true);
	};

	const handleDecrease = () => {
		if (qty > 1) setQty(qty - 1);
	};

	const handleIncrease = () => {
		if (hasStock && qty >= availableStock) return;
    setQty(qty + 1);
	};

	// const handleChange = (e) => {
	// 	const val = Number(e.target.value);
	// 	if (!isNaN(val) && val >= 1) {
	// 		setQty(val);
	// 		setQtyError({ error: false, msg: t('*Required') });
	// 	}
	// };

	// setProqty(data.qty);

	const handleChange = (e) => {
    const val = e.target.value; 
    const numVal = Number(val);
    if (val === '') {
        setQty(1); 
        setQtyError({ error: false, msg: t('*Required') });
        return;
    }
    if (!isNaN(numVal) && numVal >= 1) {
        setQty(numVal);
        setQtyError({ error: false, msg: t('*Required') });
    }
};

	const addtempproduct = async () => {
		if (qty < 1) {
			setQtyError({ error: true, msg: t('Add at least 1 item') });
			return;
		} else if (!Number.isInteger(qty)) {
			setQtyError({ error: true, msg: t('Invalid quantity') });
			return;
		} else if (qty > data.qty) {
			setQtyError({ error: true, msg: t('Quantity exceeds stock') });
			return;
		}

		const formData = {};
		const branchid = localStorage.getItem('selectedBranch');
		formData['branch_id'] = branchid;
		formData['prod_id'] = data.id;
		formData['qty'] = qty;
		formData['total_amount'] = totprice;

		formData['action'] = 'add_individual_product';

		try {
			const flechdata = await apiService(formData, token, setToken, navigate);
			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				addItemToCart();
				closemodel();
				startmodel2();
			} else {
				console.log('error');
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	const handleSelectChange = (e) => {
		setSelectedItem(e.target.value);
	};

	const onConform = () => {
		addtempproduct();
	};

	const onClose = () => {
		setQuantityError({});
		setSelectorError({ error: false, msg: t('*Required') });
		setSelectedProducts([]);
		closemodel();
	};

	const handleRemoveItem = (index) => {
		setSelectedProducts((prevProducts) => prevProducts.filter((item, i) => i !== index));
	};

	return (
		<>
			<CartConfModal
				isopen={condialog}
				onclose={closemodel2}
				continuebt={OnClickToCustomer}
				confirmpaybt={OnClickToCart}
				isMobile={isMobile}
			/>
			<Modal
				aria-labelledby='transition-modal-title'
				aria-describedby='transition-modal-description'
				open={loadalert}
				onClose={(_, reason) => reason === 'backdropClick' && onClose}
				closeAfterTransition
				slots={{ backdrop: StyledBackdrop }}>
				<Fade in={loadalert}>
					<ModalContent>
						<div className='product-modal-container'>
							<div className='top-container'>
								<div className='col-12 m-3'>
									<CardLabel>
										<CardTitle className='header-text' tag='h4'>
											Product Purchase
										</CardTitle>
									</CardLabel>
								</div>
								<div className='divider' />
								<div className='product-table'>
									<ul>
										<li
											style={{
												alignItems: 'unset',
												paddingTop: '10px',
												paddingBottom: '10px',
												width: isMobile ? 'max-content' : 'unset',
											}}>
											<td style={{ flex: 3, alignContent: 'center' }}>
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														marginTop: '5px',
														minWidth: '250px',
													}}>
													<span>
														{data.name.length > 30
															? data.name.substring(0, 30) + '...'
															: data.name}
													</span>
												</div>
											</td>
											<td style={{ flex: 4 }}>
												<Label style={{ marginRight: '65px' }}>
													{t('Quantity')}
												</Label>
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														backgroundColor: '#fff',
														borderRadius: '6px',
														overflow: 'hidden',
														width: '124px',
														height: '36px',
														boxShadow: '0 0 0 1px #ccc',
													}}>
													<button
														onClick={handleDecrease}
														style={{
															width: '36px',
															height: '36px',
															border: 'none',
															background: '#fff',
															color: '#000',
															fontSize: '20px',
															cursor: 'pointer',
														}}>
														–
													</button>
													<input
														type='text'
														value={qty}
														onChange={handleChange}
														min={1}
														style={{
															width: '48px',
															height: '36px',
															textAlign: 'center',
															border: 'none',
															backgroundColor: '#fff',
															color: '#000',
															outline: 'none',
															fontSize: '16px',
														}}
													/>
													<button
														onClick={handleIncrease}
														disabled={isIncreaseDisabled}
// 														disabled={
//     selectedProducts[index].quantity <= 1 ||  qty < selectedProducts[index].quantity   
// }
														style={{
															width: '36px',
															height: '36px',
															border: 'none',
															background: '#fff',
															color: '#000',
															fontSize: '20px',
															cursor: 'pointer',
														}}>
														+
													</button>
												</div>
												<DefultError error={qtyError} />
											</td>
											{/* <td style={{ flex: 4 }}>
												<FormGroup
													id='text'
													label={t('Quantity')}
													isFloating>
													<Input
														type='number'
														className='input-container'
														placeholder={t('Quantity')}
														style={{
															border: '2px solid transparent',
														}}
														value={qty}
														onChange={(e) => {
															setQty(Number(e.target.value));
															setQtyError({
																error: false,
																msg: t('*Required'),
															});
														}}
													/>
												</FormGroup>
												<DefultError error={qtyError} />
											</td> */}
											{/* <td style={{ flex: 5 }}>
												<FormGroup
													id='totalAmount'
													label={t('Total Amount')}
													isFloating>
													<Input
														type='number'
														className='input-container'
														placeholder={t('Total Amount')}
														disabled
														style={{
															border: '2px solid transparent',
														}}
														value={totprice}
													/>
												</FormGroup>
											</td> */}
											<td style={{ flex: 5 }}>
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														marginTop: '5px',
														maxWidth: '124px',
														minWidth: '124px',
													}}>
													<FormGroup
														id='totalAmount'
														label={t('Total Amount')}>
														<Input
															type='number'
															className='input-container'
															placeholder={t('Total Amount')}
															disabled
															style={{
																border: '2px solid transparent',
															}}
															value={totprice}
														/>
													</FormGroup>
												</div>
											</td>
										</li>
									</ul>
								</div>
							</div>

							<div className='bottom-container row'>
								<div className='col text-center h-100 d-flex align-items-center justify-content-center p-0'>
									<button
										type='button'
										className='btn btn cancel-button'
										onClick={onClose}
										style={{
											boxShadow: 'none',
										}}
										data-mdb-ripple-init>
										{t('Close')}
									</button>
								</div>
								<div className='col d-flex align-items-center justify-content-center p-0'>
									<button
										type='button'
										className='btn btn confirm-button'
										disabled={!qty}
										onClick={onConform}
										style={{
											boxShadow: 'none',
										}}
										data-mdb-ripple-init>
										{t('Confirm')}
									</button>
								</div>
							</div>
						</div>
					</ModalContent>
				</Fade>
			</Modal>
		</>
	);
};

const DefultError = ({ error }) => {
	return (
		error.error && (
			<p
				style={{
					color: '#D8000C',
					backgroundColor: '#FFD2D2',
					fontSize: '10px',
					padding: '2px 6px', // reduced padding
					borderRadius: '4px', // slightly smaller border radius
					display: 'flex',
					alignItems: 'center',
					gap: '4px',
					margin: '2px 0 0 0', // marginTop only, no horizontal margin
					fontFamily: 'Segoe UI, sans-serif',
					width: 'fit-content', // fits to content only
					maxWidth: '100%',
				}}>
				<span style={{ fontWeight: 'bold' }}>⚠</span>
				{error.msg || t('*Required')}
			</p>
		)
	);
};

const Backdrop = React.forwardRef((props, ref) => {
	const { open, ...other } = props;
	return (
		<Fade in={open}>
			<div ref={ref} {...other} />
		</Fade>
	);
});

Backdrop.propTypes = {
	open: PropTypes.bool,
};

const blue = {
	200: '#99CCFF',
	300: '#66B2FF',
	400: '#3399FF',
	500: '#007FFF',
	600: '#0072E5',
	700: '#0066CC',
};

const grey = {
	50: '#F3F6F9',
	100: '#E5EAF2',
	200: '#DAE2ED',
	300: '#C7D0DD',
	400: '#B0B8C4',
	500: '#9DA8B7',
	600: '#6B7A90',
	700: '#434D5B',
	800: '#303740',
	900: '#1C2025',
};

const Modal = styled(BaseModal)`
	position: fixed;
	z-index: 1300;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
	z-index: -1;
	position: fixed;
	inset: 0;
	background-color: rgb(0 0 0 / 0.57);
	-webkit-tap-highlight-color: transparent;
`;

const ModalContent = styled('div')(
	({ theme }) => css`
		margin: 0 auto;
		width: 95%; /* xs (default: <600px) */
		text-align: center;
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 8px;
		overflow: hidden;
		background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
		border-radius: 20px;
		border: 0px solid transparent;
		outline: none;
		box-shadow: 0 4px 12px
			${theme.palette.mode === 'dark' ? 'rgb(0 0 0 / 0.5)' : 'rgb(0 0 0 / 0.2)'};
		padding: 0px;
		color: ${theme.palette.mode === 'dark' ? grey[50] : grey[900]};

		/* If screen < 649px → 90% width */
		@media (max-width: 649px) {
			width: 90%;
		}

		${theme.breakpoints.up('sm')} {
			/* ≥600px */
			width: 85%;
		}
		${theme.breakpoints.up('md')} {
			/* ≥900px */
			width: 70%;
		}
		${theme.breakpoints.up('lg')} {
			/* ≥1200px */
			width: 55%;
		}
		${theme.breakpoints.up('xl')} {
			/* ≥1536px */
			width: 40%;
		}
		@media (min-width: 1800px) {
			width: 35%;
		}

		& .modal-title {
			color: white;
			margin: 0;
			line-height: 1.5rem;
			margin-bottom: 8px;
		}

		& .modal-description {
			margin: 0;
			line-height: 1.5rem;
			font-weight: 400;
			color: ${theme.palette.mode === 'dark' ? grey[400] : grey[800]};
			margin-bottom: 4px;
		}
	`,
);
